(function () {
  "use strict";

  function qsa(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function money(cents) {
    if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents);
    return (cents / 100).toLocaleString("en-US", { style: "currency", currency: window.Shopify?.currency?.active || "USD" });
  }

  function cartUrl(path) {
    var root = window.Shopify && Shopify.routes ? Shopify.routes.root : "/";
    return root + path.replace(/^\//, "");
  }

  function renderCart(drawer, cart) {
    var items = drawer.querySelector("[data-imagine-cart-items]");
    var subtotal = drawer.querySelector("[data-imagine-cart-subtotal]");
    if (!items) return;
    if (window.ImagineTheme) window.ImagineTheme.updateCartCount(cart.item_count);
    if (subtotal) subtotal.textContent = money(cart.total_price);

    if (!cart.items.length) {
      items.innerHTML = '<div class="imagine-empty">Your cart is empty.</div>';
      return;
    }

    items.innerHTML = cart.items.map(function (item) {
      var image = item.image ? '<img src="' + item.image + '&width=160" alt="' + item.product_title.replace(/"/g, "&quot;") + '" loading="lazy">' : '<div class="imagine-placeholder-media"></div>';
      return '<article class="imagine-cart-item" data-key="' + item.key + '">' +
        image +
        '<div><h3>' + item.product_title + '</h3><span>' + money(item.final_line_price) + '</span>' +
        '<div class="imagine-quantity"><button type="button" aria-label="Decrease quantity" data-imagine-cart-change="' + item.key + '" data-quantity="' + (item.quantity - 1) + '">-</button><span>' + item.quantity + '</span><button type="button" aria-label="Increase quantity" data-imagine-cart-change="' + item.key + '" data-quantity="' + (item.quantity + 1) + '">+</button></div>' +
        '<button class="imagine-quick-add" type="button" data-imagine-cart-change="' + item.key + '" data-quantity="0">Remove</button></div>' +
      '</article>';
    }).join("");
  }

  function fetchCart(drawer) {
    return fetch(cartUrl("/cart.js"), { credentials: "same-origin" })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        if (drawer) renderCart(drawer, cart);
        if (window.ImagineTheme) window.ImagineTheme.updateCartCount(cart.item_count);
        return cart;
      });
  }

  function addVariant(variantId, quantity) {
    return fetch(cartUrl("/cart/add.js"), {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: Number(variantId), quantity: quantity || 1 })
    }).then(function (response) {
      if (!response.ok) return response.json().then(function (error) { throw error; });
      return response.json();
    });
  }

  function changeLine(key, quantity) {
    return fetch(cartUrl("/cart/change.js"), {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: key, quantity: Number(quantity) })
    }).then(function (response) { return response.json(); });
  }

  function init(root) {
    qsa("[data-imagine-cart-drawer]", root).forEach(function (drawer) {
      if (!drawer.dataset.imagineCartBound) {
        drawer.dataset.imagineCartBound = "true";
        drawer.addEventListener("click", function (event) {
          var change = event.target.closest("[data-imagine-cart-change]");
          if (!change) return;
          changeLine(change.getAttribute("data-imagine-cart-change"), change.getAttribute("data-quantity"))
            .then(function (cart) { renderCart(drawer, cart); })
            .catch(function () { if (window.ImagineTheme) window.ImagineTheme.toast("Cart could not be updated."); });
        });
      }
      fetchCart(drawer);
    });

    qsa("[data-imagine-add-variant]", root).forEach(function (button) {
      if (button.dataset.imagineCartBound) return;
      button.dataset.imagineCartBound = "true";
      button.addEventListener("click", function () {
        button.disabled = true;
        addVariant(button.getAttribute("data-imagine-add-variant"), 1)
          .then(function () {
            return fetchCart(document.querySelector("[data-imagine-cart-drawer]"));
          })
          .then(function () {
            if (window.ImagineTheme) window.ImagineTheme.toast((button.getAttribute("data-product-title") || "Product") + " added to cart.");
          })
          .catch(function (error) {
            if (window.ImagineTheme) window.ImagineTheme.toast(error.description || "Product could not be added.");
          })
          .finally(function () {
            button.disabled = false;
          });
      });
    });
  }

  function queueCanonicalCartSync(event) {
    var refresh = function () {
      return fetchCart(document.querySelector("[data-imagine-cart-drawer]"));
    };

    if (event && event.promise && typeof event.promise.then === "function") {
      Promise.resolve(event.promise).then(refresh, refresh);
      return;
    }

    window.setTimeout(refresh, 0);
  }

  document.addEventListener("DOMContentLoaded", function () { init(document); });
  document.addEventListener("shopify:cart:lines-update", queueCanonicalCartSync);
  document.addEventListener("shopify:cart:error", queueCanonicalCartSync);
  window.ImagineCartDrawer = { init: init, fetchCart: fetchCart };
})();
